module.exports = __webpack_public_path__ + "static/media/sad-active.5bde5eef.svg";